import {WIDGET_KEYS} from "./WidgetKeys.jsx";
import {
  defaultCellRenderer,
  defaultCellRenderer as renderer,
  defaultGroupRenderer as groupRenderer, getCustomGroupRenderer, getOriginalRecord
} from "../utils/utils.jsx";
import { customGroupByOrder } from "../utils/otherUtils.jsx";

export const CONTACT_VIEW_COLUMNS = [
  {
    id: "name",
    field: "name",
    text: "Name",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    renderer,
    groupRenderer,
  },
  {
    id: "phone",
    field: "phone",
    text: "Phone",
    flex: 1,
    type: WIDGET_KEYS.columnPhoneNumber,
    cellCls: "swivu-phone-column swivu-copy-icon-cell",
    renderer: ({ value }) => {
      const dataset = (v) => ({
        id: v.id,
        type: v.type,
      });

      const icon = value ? {
        tag: "i",
        class: "fa-thin fa-copy cursor-pointer dark:text-[#ffffff] text-[#000000] transition-colors duration-300 ease-in-out hover:opacity-70",
        dataset: dataset({ id: "phone", type: "iconType" }),
      } : "";

      return [
        {
          tag: "span",
          text: defaultCellRenderer({ value }),
          class: "mr-[0.5em]",
        },
        icon
      ]
    },
  },
  {
    id: "email",
    field: "email",
    text: "Email",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    editor: WIDGET_KEYS.fieldEmail,
    cellCls: "swivu-copy-icon-cell",
    renderer: ({ value }) => {
      const dataset = (v) => ({
        id: v.id,
        type: v.type,
      });

      const icon = value ? {
        tag: "i",
        class: "fa-thin fa-copy cursor-pointer dark:text-[#ffffff] text-[#000000] transition-colors duration-300 ease-in-out hover:opacity-70",
        dataset: dataset({ id: "email", type: "iconType" }),
      } : "";

      return [
        {
          tag: "span",
          text: defaultCellRenderer({ value }),
          class: "mr-[0.5em]",
        },
        icon
      ]
    },
    groupRenderer,
  },
  {
    id: "address",
    field: "address",
    text: "Address",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    renderer,
    groupRenderer,
  },
  {
    id: "status",
    swivuListTitle: "Status",
    type: WIDGET_KEYS.columnContactStatus,
    field: "statusValue",
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    }
  },
  {
    id: "category",
    swivuListTitle: "Category",
    type: WIDGET_KEYS.columnContactCategory,
    field: "categoryValue",
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    }
  },
  {
    id: "tags",
    swivuListTitle: "Tags",
    type: WIDGET_KEYS.columnContactTag,
    field: "_tags",
  },
  {
    id: "entities", // this id is used else where in ContactPage file
    field: "entitiesValue",
    text: "Linked To",
    type: WIDGET_KEYS.swivuSortColumn,
    editor: false,
    cellCls: "swivu-recipients-cell flex gap-[0.5em]",
    groupRenderer(e) {
      return getCustomGroupRenderer(e);
    },
    renderer({ record }) {
      const originalRecord = getOriginalRecord(record);
      const dataset = (v) => ({
        id: v.id.split("-")[1],
        type: v.type,
      });
      return ((originalRecord.entities ?? originalRecord.contactRecord?.entities) || []).map((v) => ({
        tag: "div",
        class: "entity-main-name-column border-0 outline-0 cursor-pointer",
        dataset: dataset(v),
        children: [{
          tag: "span",
          class: "entity-main-name-text",
          dataset: dataset(v),
          text: defaultCellRenderer({ value: v.name }),
        }]
      }));
    },
  },
]
